<script setup lang="ts">

import {onMounted, ref} from "vue";

let payments = ref<Array<{name: string, image: string}>>([]);

onMounted(() => {
    payments.value = [
        {name: 'Bancontact', image: '/images/payments/Bancontact.webp'},
        {name: 'ING', image: '/images/payments/ING.webp'},
        {name: 'KBC', image: '/images/payments/KBC.webp'},
        {name: 'Belfius', image: '/images/payments/Belfius.webp'},
        {name: 'Visa', image: '/images/payments/Visa.webp'},
        {name: 'Mastercard', image: '/images/payments/Mastercard.webp'},
        {name: 'iDeal', image: '/images/payments/Ideal.webp'},
    ];
});

</script>
<template>
    <div class="component-payment-methods">
        <div
            v-for="payment in payments"
            :key="payment.name"
        >
            <img
                :src="payment.image"
                :alt="payment.name"
            />
        </div>
    </div>
</template>
<style scoped lang="scss">
@use "@scss/components/payment-methods";
</style>
